import { Box, colors, Paper, styled, SxProps, Tabs, Typography, useTheme } from "@mui/material";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";
import CommonDialog from "../../../components/CommonDialog/CommonDialog";
import { DrawerWithoutBackground } from "../../../components/PartDetails/DrawerPart/DrawerPartDetails.styles";

export const Root = styled("div", { label: "machine_more-Page" })
    (({ theme }) => ({
        display: "flex",
        flex: 1,
        flexDirection: "column",
        width: '100%',
    }))

export const Content = styled("div", { label: "machine_more-content" })(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    '.MuiTabs-root': {
        ".MuiButtonBase-root": {
            color: StyleguideSavioColors.text.grayTitles,
            fontWeight: StyleguideSavioFonts.bold,

            "&.Mui-disabled": {
                color: StyleguideSavioColors.lightGrey
            },
            "&.Mui-selected": {
                opacity: 1,
                color: StyleguideSavioColors.blue,
            },

            "&:not(.Mui-disabled):hover": { color: StyleguideSavioColors.blue, }
        }
    }
}));

export const StylePathBox = styled(Box, {
    label: "historyHeader_Typography",
})(({ theme }) => ({
    width: "100%",
    display: "inline",

}));

export const SectionTabs = styled(Tabs, { label: "machine_more-Typography" })
    (({ theme }) => ({

    }))

export const TabsContent = styled(Box, { label: "machine_more-Container" })
    (({ theme }) => ({
        display: "flex",
        height: 'calc(100vh - 200px)',

        'table + div':{
            display: 'none',
        },

        "> .MuiBox-root": {
            position: 'relative',
            "> .MuiBox-root": {
                height: '100%',
                "> .MuiBox-root": {
                    height: 'calc(100% - 18px)',

                    "[role='presentation']": {
                        position: "fixed",
                        left: 0,
                        bottom: 85,
                    }
                }
            }
        },
        "table tbody svg": { fontSize: 26 + "px !important", marginTop: 5, },
        ".technicalInfo ": {
            "svg:not(button svg)": {
                marginTop: 0,
                marginRight: 6,
            },
            "td": {
                "> div": {
                    alignItems: 'center',
                }
            }
        },

    }))

    export const PageTitle = styled("div", { label: "InstalledBasePage-pageTitle" })(({ theme }) => ({
        display: "flex",
        padding: "6px 0",
        color: StyleguideSavioColors.text.grayTitles,
        fontSize: 20,
        fontWeight: StyleguideSavioFonts.bold,
        alignItems: 'center',
        height: 46,
        'svg':{
            marginRight: 5,
        }
      })
      );

export const TabsComponentStyled = styled(TabsContent, { label: "tabs_component_styled" })
    (({ theme }) => ({
        width: '100%',
        borderTop: '1px solid' + StyleguideSavioColors.lightGrey,



        height: 'calc(100vh - 332px)',
        transition: theme.transitions.create("height"),
        //TODO: quando si clicca sul bottone dei filtri bisogna aggiungere questa classe, quando si riclicca nascondendoli bisogna toglierla (ci sono 2 classi differenti se sei in order o offer)
        '&.filtersOpened_orders':{
            height: 'calc(100vh - 610px)',
        },

        '&.filtersOpened_offers':{
            height: 'calc(100vh - 542px)',
        },

        'th': {
           
            '&.conditions  ': {
                width: 60
            }, '&.note  ': {
                width: 33
            }, '&.orderStatus   ': {
                width: 60
            }, '&.orderType  ': {
                width: 60
            }, '&.orderCode   ': {
                width: 64
            },
            '&.customerReference ': {
                width: 135
            },
            '&.orderDate, &.deliveryDate  ': {
                width: 72
            }, '&.offerCode  ': {
                width: 68
            }, '&.offerStatus  ': {
                width: 66
            },
           
        },
        'tr:hover':{
           
            'td':{
                '&.netTotalAmount, &.offerRequestDate':{
                   textDecoration: 'none !important',
                }
            }
        }
    }))

export const StyledCommonDialog = styled(CommonDialog, { label: "commonDialog_component_styled" })
    (({ theme, sx }) => ({

        '& .MuiDialog-paper': {
            width: '90% !important',
            height: '90% !important',
            margin: 0,
            borderRadius: '8px',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            ...sx,
            
        },
        '& .MuiDialogContent-root': {
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            flex: 1,
            padding: theme.spacing(2),
        },
        '& .MuiDialogTitle-root': {
            padding: theme.spacing(2),
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
            justifyContent: 'space-between',
        },
    }));

export const useClasses = () => {
    const theme = useTheme();

    const classes = {
        tabs: {
            display: "flex",
            width: 1 / 1,
            padding: 0,
            minHeight: 0,
            backgroundColor: "#fff",
            borderBottom: '1px solid' + StyleguideSavioColors.lightGrey,

            "button": { paddingTop: "10px", },
            "svg": {
                marginTop: "-3px",
            },

            "&::before": {
                content: "'/'",
                position: "absolute",
                fontSize: 37,
                top: -6,
                color: StyleguideSavioColors.lightGrey,
                left: "calc(50% - 8px)",
            },



        } as SxProps,

        tab: {
            flex: 1,
            flexGrow: 1,
            minHeight: 44,
            fontWeight: StyleguideSavioFonts.medium,
            color: StyleguideSavioColors.text.black,
            overflow: 'visible',
            maxWidth: "none",
            position: 'relative',


            "&.Mui-selected": {
                color: StyleguideSavioColors.blue,
            },
            "&.Mui-disabled": {
                color: StyleguideSavioColors.lightGrey,
            },
            "&:hover": {
                color: StyleguideSavioColors.blue,
            },


            "&:nth-of-type(1)": {
                marginRight: "8px",
            },
            "&:nth-of-type(2)": {
                marginLeft: "8px",
                marginRight: "8px",
            },
            "&:nth-of-type(3)": {
                marginLeft: "8px",
            },
        } as SxProps,

        iconSize: {
            fontSize: 26 + "px !important",
            marginTop: '11px',
        },
    };

    return classes;

}